import clsx from 'clsx';
import React from 'react';

import MarketingLeadCaptureWithApple from '@components/OAuthButtons/MarketingLeadCaptureWithApple';
import MarketingLeadCaptureWithGoogle from '@components/OAuthButtons/MarketingLeadCaptureWithGoogle';
import useServerSideRendering from '@hooks/useServerSideRendering';
import { AppleEventName, GoogleEventName } from '@utils/backend-api/oauth';
import { FormLocation } from '@utils/enums';
import { LeadType } from '@utils/types';

export interface OAuthButtonsProps {
  articleId?: number;
  briefingGuid?: string;
  buttonWidth?: number;
  className?: string;
  isGdprOptIn?: boolean;
  leadType: LeadType;
  newsletterIds?: number[];
  oauthButtonsClassName?: string;
  redirectToOnSuccess: string;
  shareGuid?: string;
  unlockContent?: boolean;
}

const OAuthButtons = ({
  articleId,
  briefingGuid,
  buttonWidth,
  isGdprOptIn,
  leadType,
  newsletterIds,
  oauthButtonsClassName,
  redirectToOnSuccess,
  shareGuid,
  unlockContent,
}: OAuthButtonsProps) => {
  const hydrated = useServerSideRendering();
  const googleEventName = unlockContent
    ? GoogleEventName.UnlockContent
    : GoogleEventName.CreateLead;
  const appleEventName = unlockContent ? AppleEventName.UnlockContent : AppleEventName.CreateLead;

  return (
    <>
      {hydrated ? (
        <>
          <div
            className={clsx(
              'flex min-h-40 grid-flow-row-dense flex-col items-center sm:mb-0',
              oauthButtonsClassName
            )}
          >
            <MarketingLeadCaptureWithGoogle
              articleId={articleId}
              briefingGuid={briefingGuid}
              buttonWidth={buttonWidth}
              eventName={googleEventName}
              formLocation={FormLocation.Paywall}
              isGdprOptIn={isGdprOptIn}
              leadType={leadType}
              newsletterIds={newsletterIds}
              redirectToOnSuccess={redirectToOnSuccess}
              shareGuid={shareGuid}
            />
          </div>
          <div
            className={clsx(
              'mt-8 flex min-h-40 flex-col items-center sm:mb-0 sm:mt-0',
              oauthButtonsClassName
            )}
          >
            <MarketingLeadCaptureWithApple
              articleId={articleId}
              briefingGuid={briefingGuid}
              eventName={appleEventName}
              formLocation={FormLocation.Paywall}
              isGdprOptIn={isGdprOptIn}
              leadType={leadType}
              newsletterIds={newsletterIds}
              redirectToOnSuccess={redirectToOnSuccess}
              shareGuid={shareGuid}
            />
          </div>
        </>
      ) : (
        <div className="h-40" />
      )}
    </>
  );
};

export default OAuthButtons;
